import PropTypes from 'prop-types';

import React, {Component} from 'react';
import * as MuiCore from '@material-ui/core';
import IntlTelInput from 'react-intl-tel-input';

const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
const PNF = require('google-libphonenumber').PhoneNumberFormat;

class PhoneTextFieldWithFlag extends Component {
    constructor(props){
        super(props);
        this.inputRef = React.createRef();

        this.digits = '';
    }

    state = {
        phoneNumber: '',
        countryData: '',
        countryCode: '+1',
        initNum: '',
        propogate: false,
        fullNum: '',
        displayNum: '',
        phoneValidated: false
    }

    insertDigit = (digit) => {
        let num = this.state.phoneNumber + digit;
        try {
            var tel = phoneUtil.parse((this.state.countryCode === '' ? "+1" : this.state.countryCode)  + num.replace(/[^0-9]/g, ''));
            this.setState({displayNum: phoneUtil.format(tel, PNF.NATIONAL), phoneNumber: num})
        }catch(error){
            this.setState({phoneNumber: num, displayNum: ''})
        }
      }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.caller === 'phonepad'){
            if(this.state.initNum === '' && prevState.countryCode !== this.state.countryCode && this.state.phoneNumber !== ''){
                this.props.onPhoneNumberChange(this.state.countryCode + this.state.phoneNumber.replace(/[^0-9]/g, ''))
            }
            if(this.state.initNum === '' && prevState.countryCode === this.state.countryCode && this.state.phoneNumber !== ''){
                this.props.onPhoneNumberChange(this.state.countryCode + this.state.phoneNumber.replace(/[^0-9]/g, ''))
            }
        }   
    }

    componentDidMount() {
        if (typeof(this.props.insertFunction) === 'function') {
          this.props.insertFunction(this.insertDigit);
        }
      }
    
    componentWillUnmount(){
        this.setState({
            phoneNumber: '',
            countryData: '',
            countryCode: '+1',
            initNum: '',
            propogate: false,
            fullNum: ''
        })
    }

    getDefaultCountry = (phoneNumber) => {
        try{
            var phone = "+" + phoneNumber.replace(/[^0-9]/g, '');
            var tel = phoneUtil.parse(phone);
        } catch(error){ 
            return window.location.hostname.includes('uk') ? 'gb' : 'us';
        }
        if(phoneUtil.getRegionCodeForNumber(tel)){
            return phoneUtil.getRegionCodeForNumber(tel).toLowerCase();
        }
        return "";
    }

    handleIntlPhoneChange = (status, value, countryData, number, id) => {
        try {
            var tel = phoneUtil.parse(("+" + countryData.dialCode  + value.replace(/[^0-9]/g, '')), countryData.iso2.toUpperCase());
            if(tel.values_['4']){
                this.handleIntlPhoneChange(status, value.slice(1), countryData, number.slice(1), id)
                return;
            }
            var region = countryData.iso2;
            var exampleNumber = phoneUtil.getExampleNumber(region.toUpperCase()).values_;
            if(tel.values_['1'] === exampleNumber['1'] && String(tel.values_['2']).length === String(exampleNumber['2']).length){
                if(typeof(this.props.isValid) === 'function'){
                    this.props.isValid(true)
                }
                if(typeof(this.props.regionChange) === 'function'){
                    this.props.regionChange(countryData.iso2)
                }
                if(this.state.initNum === ''){
                    this.setState({initNum: this.props.value});
                }
                this.setState({ phoneNumber: phoneUtil.format(tel, PNF.NATIONAL), countryData: countryData, displayNum: '' });
                if(countryData.dialCode !== undefined){
                    this.setState({ countryCode: "+" + countryData.dialCode });
                }
                if(typeof(this.props.onPhoneNumberChange) === 'function' && this.state.propogate ){
                    this.props.onPhoneNumberChange("+" + number.replace(/[^0-9]/g, ''))
                }
                this.setState({phoneValidated: true});
            }else{
                if(typeof(this.props.isValid) === 'function'){
                    this.props.isValid(false)
                }
                if(typeof(this.props.regionChange) === 'function'){
                    this.props.regionChange(countryData.iso2)
                }
                if(this.state.initNum === ''){
                    this.setState({initNum: this.props.value});
                }
                this.setState({ phoneNumber: value !== "+" ? value : '', countryData: countryData, displayNum: '' });
                if(countryData.dialCode !== undefined){
                    this.setState({ countryCode: "+" + countryData.dialCode });
                }
                if(typeof(this.props.onPhoneNumberChange) === 'function' && this.state.propogate ){
                    this.props.onPhoneNumberChange("+" + number.replace(/[^0-9]/g, ''))
                }  
                this.setState({phoneValidated: false}); 
            }
        }catch(error){
            if(typeof(this.props.isValid) === 'function'){
                this.props.isValid(false)
            }
            if(typeof(this.props.regionChange) === 'function'){
                this.props.regionChange(countryData.iso2)
            }
            if(this.state.initNum === ''){
                this.setState({initNum: this.props.value});
            }
            this.setState({ phoneNumber: value !== "+" ? value : '', countryData: countryData, displayNum: '' });
            if(countryData.dialCode !== undefined){
                this.setState({ countryCode: "+" + countryData.dialCode });
            }
            if(typeof(this.props.onPhoneNumberChange) === 'function' && this.state.propogate ){
                this.props.onPhoneNumberChange("+" + number.replace(/[^0-9]/g, ''))
            }   
            this.setState({phoneValidated: false}); 
        }
    }

    handleFlagChange = (currentNumber, selectedCountryData, fullNumber, isValid) => {
        this.setState({phoneValidated: isValid})
        if(typeof(this.props.regionChange) === 'function'){
            this.props.regionChange(selectedCountryData.iso2)
        }
        if(selectedCountryData.dialCode !== undefined){
            this.setState({ countryCode: "+" + selectedCountryData.dialCode });
        }
        if(typeof(this.props.onPhoneNumberChange) === 'function'){
            this.props.onPhoneNumberChange("+" + selectedCountryData.dialCode + this.state.phoneNumber.replace(/[^0-9]/g, ''))
        }
        try {
            var tel = phoneUtil.parse(("+" + selectedCountryData.dialCode  + this.state.phoneNumber.replace(/[^0-9]/g, '')));
            this.setState({displayNum: phoneUtil.format(tel, PNF.NATIONAL)})
        }catch(error){

        }
    }

    handleFocusChange = (isValid, value, selectedCountryData, fullNumber, extension, event) => {
        this.setState({propogate: true})
    }

    render() {
        const {
          fullBorders,
          formClassName,
          readOnly,
          ...props
        } = this.props;
        return(
            <MuiCore.FormControl className={formClassName} 
                style={
                    readOnly
                    ? { [`border${fullBorders ? '' : 'Bottom'}`]: "none", width: "100%" }
                    : this.state.phoneValidated || this.props.deleted
                    ? { [`border${fullBorders ? '' : 'Bottom'}`]: "1px solid black", width: "100%" }
                    : { [`border${fullBorders ? '' : 'Bottom'}`]: "1px solid red", width: "100%" }
                }
            >
                <IntlTelInput
                    readOnly={readOnly}
                    onlyCountries={window.location.hostname.includes('uk') ? ['gb', 'de', 'fr', 'it', 'es', 'ie', 'pl', 'dk', 'se', 'no', 'us','nl'] : ['us']}
                    preferredCountries={window.location.hostname.includes('uk') ? ['gb'] : ['us']}
                    // onlyCountries={this.props.onlyCountries === undefined ? '' : this.props.onlyCountries}
                    // preferredCountries={this.props.onlyCountries === undefined ? ['us', 'gb'] : ''}
                    {...props}
                    insertFunction={undefined}
                    containerClassName="intl-tel-input"
                    inputClassName="MuiInputBase-input"
                    onSelectFlag={this.handleFlagChange}
                    defaultCountry={this.getDefaultCountry(this.state.initNum === '' ? this.props.value : this.state.initNum)}
                    value={this.state.phoneNumber === '' ? this.props.value === this.state.countryCode || this.props.value === '+' ? this.state.phoneNumber : this.props.value : this.state.displayNum === '' ? this.state.phoneNumber : this.state.displayNum}
                    format={true}
                    onPhoneNumberFocus={this.handleFocusChange}
                    onPhoneNumberChange={this.handleIntlPhoneChange}
                    placeholder={'(201) 555-0572'}
                    // telInputProps={{maxLength: !this.props.maxLength ? 15 : this.props.maxLength}}
                    />
            </MuiCore.FormControl>
        )
    }
}

PhoneTextFieldWithFlag.propTypes = {

    value : PropTypes.string,

    onPhoneNumberChange: PropTypes.func,

    insertFunction: PropTypes.func,

    maxLength: PropTypes.number

}

export default PhoneTextFieldWithFlag;